import IconBox from '@/components/iconBox';
import ShowHide from '@/components/showHide';
import { Company } from '@/modules/company/entities/interfaces/company';
import { DownloadUsageStatementFile } from '@/modules/copay/components/dialogRelease/downloadUsageStatementFile';
import { UsageStatement } from '@/modules/copay/entities/interfaces/usageStatements';
import ICONS from '@/shared/entities/constants/icons';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Button, Dialog, Text } from 'vkit/lib/components';
import { Grid } from 'vkit/lib/context';

interface DialogRealeaseProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  companyParentId?: string;
  callbackDownload?: (usageStatement: UsageStatement) => void;
  company?: Company;
}

export const DialogRelease: React.FC<DialogRealeaseProps> = ({
  open,
  setOpen,
  companyParentId,
  callbackDownload,
  company,
}) => {
  const [downloaded, setDownloaded] = useState(false);
  const useRefDialog = useRef({ open: () => {}, dismiss: () => {} });

  useEffect(() => {
    open ? useRefDialog.current.open() : useRefDialog.current.dismiss();
  }, [open]);

  return (
    <Dialog
      shadow
      outlined
      rounded
      instanceEmitter={useRefDialog.current}
      elevation={2}
      size='larger'
      onClose={() => {
        setOpen(false);
        setDownloaded(false);
      }}
      body={
        <>
          <ShowHide transition='slideToDown' visible={!downloaded}>
            <Grid column alignContent='center' alignItems='center' padding={30} stretch gap={32}>
              <Text value='Baixar arquivo de isenção' title color='colorDefault' size='larger' />
              <Text
                value='Selecione o mês e o ano da coparticipação que deseja baixar'
                size='medium'
              />
              <DownloadUsageStatementFile
                company={company}
                companyParentId={companyParentId}
                callbackDownload={(usageStatement: UsageStatement) => {
                  callbackDownload?.(usageStatement);
                  setDownloaded(true);
                }}
              />
            </Grid>
          </ShowHide>

          <ShowHide transition='slideToDown' visible={downloaded}>
            <Grid column alignContent='center' alignItems='center' padding={30} stretch gap={32}>
              <IconBox icon={ICONS.CHECK} size={70} circle color='success' />
              <Text
                value='Revise o arquivo de Coparticipação'
                title
                color='colorDefault'
                size='larger'
              />
              <Text
                value='Revise as informações do arquivo e, se estiver tudo certo, clique em “Aprovar” na tela de status para iniciar a coparticipação.'
                size='medium'
                textAlign='center'
              />
              <Button onClick={() => setOpen(false)} color='colorDefault'>
                <Grid padding={12} alignItems='center' alignContent='center' gap={8}>
                  Ir para status das coparticipações
                </Grid>
              </Button>
            </Grid>
          </ShowHide>
        </>
      }
    />
  );
};
